// Specialty Trailers — enclosed stacker / hauler trailer imagery.
//
// Iteration 109: Owner-approved specialty (stacker / hauler) trailer
// photography landed via the canonical manifest (see /lib/photos/manifest.js).
// This module now only exposes true enclosed stacker/hauler trailer imagery.
// The previous Prevost / interior stand-ins have been retired.
import { _ASSET_BASE } from "./_base";

const ST_HERO    = `${_ASSET_BASE}/i4p9c2i7_IMG_5634.jpeg`; // Featherlite black stacker · ramp open
const ST_ACCENT  = `${_ASSET_BASE}/otvtwep6_IMG_5633.jpeg`; // burgundy/gold stacker · Newmar match
const ST_GALLERY = `${_ASSET_BASE}/3aqxn3vw_IMG_5632.jpeg`; // maroon/white stacker · Alps · ramp open

export const SPECIALTY_TRAILER_PHOTOS = [
  ST_HERO,
  ST_ACCENT,
  ST_GALLERY,
];

const specialtyTrailers = {
  hero: ST_HERO,
  accent: ST_ACCENT,
  gallery: [ST_GALLERY],
  card: ST_HERO,
  social: ST_HERO,
};
export default specialtyTrailers;
